import React, { useState } from "react";
import {
  User,
  LockKeyhole,
  Eye,
  EyeOff,
  X,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./LoginModal.css";
import RegisterModal from "../RegisterModal/RegisterModal";
import { login } from "../../api/auth.api"; // adjust path if needed
import { showToast } from "../../components/toast"; // adjust path if needed
import { getBrandName } from "../../common/brand";
import Logo from "../../common/Logo";
export default function LoginModal({
  isOpen = true,
  onClose,
  onLogin,
  onRegister,
  onForgotPassword,
  logoSrc,
}) {
  const navigate = useNavigate();
  const brandName = getBrandName();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberWeek, setRememberWeek] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false); // was true

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await login({
        username,
        password,
      });

      if (response?.data?.status) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("remote_id", response.data.remote_id);
        localStorage.setItem("username", response.data.username);

        if (rememberWeek) {
          localStorage.setItem("rememberWeek", "true");
        } else {
          localStorage.removeItem("rememberWeek");
        }

        if (response?.exchange?.[0]?.token) {
          localStorage.setItem("exchangeToken", response.exchange[0].token);
        } else {
          localStorage.removeItem("exchangeToken");
        }

        localStorage.setItem("popup", 1);
        localStorage.setItem("regPopup", 0);

        showToast(response.data.message, "success");

        // optional callback
        if (onLogin) {
          onLogin({
            username,
            password,
            rememberWeek,
            response,
          });
        }

        // reset fields
        setUsername("");
        setPassword("");
        setShowPassword(false);

        // close modal if needed
        if (onClose) onClose();

        // redirect
        navigate("/home");
        window.location.reload()
      } else {
        showToast(response?.data?.message || "Login failed", "error");
      }
    } catch (error) {
      showToast(
        error?.response?.data?.message || error?.message || "Something went wrong",
        "error"
      );
    }
  };

  return (
    <div className="login-modal-overlay" onClick={onClose}>
      <div
        className="login-modal-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Login modal"
      >
        <button
          type="button"
          className="login-modal-close"
          onClick={onClose}
          aria-label="Close modal"
        >
          <X size={28} strokeWidth={2.6} />
        </button>

        <div className="login-modal-header">
          {logoSrc ? (
            <img src={logoSrc} alt={brandName} className="login-modal-logo" />
          ) : (
            <div className="login-modal-logo-text">
              <Logo width={80} height={70}/>
            </div>
          )}
        </div>

        <form className="login-modal-form" onSubmit={handleSubmit}>
          <div className="login-input-wrap">
            <User className="login-input-icon" size={22} strokeWidth={2.4} />
            <input
              type="text"
              placeholder="Username"
              className="login-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="login-input-wrap">
            <LockKeyhole
              className="login-input-icon"
              size={22}
              strokeWidth={2.4}
            />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? (
                <EyeOff size={22} strokeWidth={2.4} />
              ) : (
                <Eye size={22} strokeWidth={2.4} />
              )}
            </button>
          </div>

          <label className="remember-row">
            <input
              type="checkbox"
              checked={rememberWeek}
              onChange={() => setRememberWeek((prev) => !prev)}
            />
            <span className="custom-checkbox" />
            <span className="remember-text">Remember me a week</span>
          </label>

          <button type="submit" className="auth-main-btn">
            Login
          </button>

          <button
            type="button"
            className="auth-outline-btn"
            onClick={() => setOpen(true)}
          >
            Register
          </button>

          <button
            type="button"
            className="forgot-link-btn"
            onClick={()=> navigate('/forget-password')}
          >
            Forgot Password ?
          </button>
        </form>
      </div>

      <RegisterModal
        isOpen={open}
        onClose={() => setOpen(false)}
        onLogin={() => console.log("go to login")}
      />
    </div>
  );
}